const classes = {
  section: {
    paddingBottom: '4rem',
    paddingLeft: '1.25rem',
    paddingRight: '1.25rem'
  },
  gridBox: {
    display: 'grid',
    width: '100%',
    columnGap: 2,
    rowGap: 4
  },
  cardBox: {
    display: 'flex',
    background: '#fff',
    flexDirection: 'column' as const,
    justtifyContent: 'space-between',
    height: '100%',
    width: '100%',
    '&:hover': {
      cursor: 'pointer',
      transform: 'scale(1.03)',
      transition: 'transform 200ms'
    }
  },
  typeH4: {
    fontWeight: 600,
    margin: '0 15px 0 15px',
    height: '30px'
  },
  typeH4b: {
    fontWeight: 400,
    margin: '0 15px 0 15px',
    flexGrow: 1
  }
}

export default classes
